<template>
  <div>

    <div class="title-section">
      <div class="display-1 font-weight-bold">{{meta.title}}</div>
      <div class="subheading">{{meta.subtitle}}</div>
    </div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Texturing!</div><v-divider class="div-after"/>
    <div class="body-1">
      Refraction, without shadow rays being adjusted by transparency. Also ensured that
      recursive rays are accounting for background radiance now. 
    </div>
    <v-img class="u-image" :src="require(`../assets/updates/9/ref_1.png`)"/>
      <div class="font-weight-medium">Basic Refraction</div>
    <v-img class="u-image" :src="require(`../assets/updates/9/added_bounces.png`)"/>
      <div class="font-weight-medium">Added Bounces</div>
    <v-img class="u-image" :src="require(`../assets/updates/9/stronger_light.png`)"/>
      <div class="font-weight-medium">Stronger Lighting</div>
    <v-img class="u-image" :src="require(`../assets/updates/9/colors.png`)"/>
      <div class="font-weight-medium">Colors!</div>
    <v-img class="u-image" :src="require(`../assets/updates/9/colors_2.png`)"/>
      <div class="font-weight-medium">More Colors!</div>
    <v-img class="u-image" :src="require(`../assets/updates/9/same_index.png`)"/>
      <div class="font-weight-medium">Same index</div>
    <v-img class="u-image" :src="require(`../assets/updates/9/higher_sphere_index.png`)"/>
      <div class="font-weight-medium">Higher internal index</div>


  </div>
</template>

<script>
import CardList from '../components/CardList';

export default {
  name: 'U_9',
  components: { CardList, },
  data() {
    return {
    };
  },
  computed: {
    meta() {
      return this.$store.state.updates[9];
    },
  },
}
</script>

<style>

</style>
